import DOMPurify from "dompurify";

export default function useHtmlUtilities(): any {
  function isElementVisible(target: HTMLElement, container: HTMLElement) {
    container = container || document.body;
    const { top, bottom, height } = target.getBoundingClientRect();
    const holderRect = container.getBoundingClientRect();

    return top <= holderRect.top
      ? holderRect.top - top <= height
      : bottom - holderRect.bottom <= height;
  }

  function decodeHTMLEncodedStr(text: string) {
    const textArea = document.createElement("textarea");
    if (text) {
      // Extra pre-processing to remove {{ }} from content prior to sanitizing
      // potential limitation is if emails or passwords have curly braces...need to determine how we want to handle this -LS06302023
      const newText = (text || "").replaceAll(/\{|\}/gi, "");

      // remove amp;
      const cleanedText = newText.replaceAll("amp;", "");
      textArea.innerHTML = DOMPurify.sanitize(cleanedText);
      let decodedText = textArea.value;
      // Apply humanized name formatting
      decodedText = humanizeName(decodedText);
      return decodedText;
    }
  }

  function humanizeName(name: string): string {
    if (!name?.trim()) return "";
    // Convert to title case
    let result = name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    // Fix Roman numerals (I through XIII)
    result = result.replace(/\b(I|Ii|Iii|Iv|V|Vi|Vii|Viii|Ix|X|Xi|Xii|Xiii)\b/gi, match =>
      match.toUpperCase(),
    );
    return result;
  }

  function isColorDark(hexColor: string) {
    // Convert hex to RGB
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    // Calculate luminance (perceived brightness)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    // Determine if light or dark based on a threshold (e.g., 0.5)
    return luminance < 0.5;
  }
	
  return { isElementVisible, decodeHTMLEncodedStr, isColorDark };
}
